const testimonials = [
  {
    id: 1,
    name: 'María L.',
    age: 32,
    location: 'Madrid',
    product: 'Soraya Wave',
    rating: 5,
    text: 'Soraya me cambió la vida. Es el lujo convertido en orgasmo. Nunca pensé que algo pudiera ser tan elegante y tan intenso a la vez.',
    avatar: 'https://public.readdy.ai/ai/img_res/faf1121c551d7a5acd19e5ed7985834a.jpg'
  },
  {
    id: 2,
    name: 'Laura S.',
    age: 28,
    location: 'Barcelona',
    product: 'Sona 2 Cruise',
    rating: 5,
    text: 'Sona es mi secreto personal. Silencioso, delicado y muy intenso. Lo uso casi todas las noches y cada vez es una experiencia diferente.',
    avatar: 'https://readdy.ai/api/search-image?query=beautiful%20woman%20portrait%20age%2028%20gentle%20smile%20natural%20makeup%20soft%20studio%20lighting%20professional%20headshot%20clean%20white%20background%20elegant%20feminine%20style&width=200&height=200&seq=test002&orientation=squarish'
  },
  {
    id: 3,
    name: 'Carmen R.',
    age: 35,
    location: 'Valencia',
    product: 'Tiani 3',
    rating: 5,
    text: 'Mi pareja y yo estamos encantados con Tiani. Ha revolucionado nuestra intimidad. El control remoto añade un toque de diversión increíble.',
    avatar: 'https://readdy.ai/api/search-image?query=confident%20woman%20portrait%20age%2035%20warm%20smile%20professional%20photography%20natural%20beauty%20soft%20lighting%20headshot%20clean%20background%20sophisticated%20elegant%20style&width=200&height=200&seq=test003&orientation=squarish'
  }
];

export default function Testimonials() {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-pink-100 text-pink-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-chat-heart-line"></i>
            <span>Opiniones reales</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 px-2">
            Lo que dicen nuestras clientas
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            Miles de mujeres ya han descubierto el placer premium con LELO
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gradient-to-br from-pink-50/50 to-fuchsia-50/30 rounded-2xl sm:rounded-3xl p-6 sm:p-8 hover:shadow-2xl hover:shadow-fuchsia-200/30 transition-all duration-300 border border-pink-100/50"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-lg sm:text-xl text-yellow-400"></i>
                ))}
              </div>

              {/* Quote */}
              <div className="mb-6">
                <i className="ri-double-quotes-l text-3xl sm:text-4xl text-fuchsia-300 mb-2"></i>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed italic">
                  {testimonial.text}
                </p>
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 sm:gap-4 pt-6 border-t border-pink-200/50">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    width="56"
                    height="56"
                  />
                </div>
                <div className="min-w-0">
                  <p className="font-bold text-sm sm:text-base text-gray-900 truncate">{testimonial.name}</p>
                  <p className="text-xs sm:text-sm text-gray-600 truncate">{testimonial.age} años • {testimonial.location}</p>
                  <p className="text-xs text-fuchsia-600 font-semibold mt-1 truncate">{testimonial.product}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-12 sm:mt-16 flex flex-wrap justify-center items-center gap-4 sm:gap-6 md:gap-8 text-gray-600 px-2">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-xl sm:text-2xl text-green-500"></i>
            <span className="text-xs sm:text-sm font-semibold">Compra segura</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-truck-line text-xl sm:text-2xl text-blue-500"></i>
            <span className="text-xs sm:text-sm font-semibold">Envío discreto</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-customer-service-2-line text-xl sm:text-2xl text-fuchsia-500"></i>
            <span className="text-xs sm:text-sm font-semibold">Atención 24/7</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-award-line text-xl sm:text-2xl text-yellow-500"></i>
            <span className="text-xs sm:text-sm font-semibold">Garantía oficial</span>
          </div>
        </div>
      </div>
    </section>
  );
}
